
<template>
    <!-- 提交中标结果 -->
    <el-dialog title="提交中标结果" :visible.sync="showDialog">
        <el-form :model="dataForm" ref="refDataForm"  :rules="rules"  size="small" label-width="150px">
            <el-form-item label="保险公司" prop="insuranceCompany">
                <el-input v-model="dataForm.insuranceCompany" disabled></el-input>
            </el-form-item>
            <el-form-item label="CaseId" prop="caseId">
                <el-input v-model="dataForm.caseId" disabled></el-input>
            </el-form-item>
            <el-form-item label="案件编号" prop="caseSn">
                <el-input v-model="dataForm.caseSn" disabled></el-input>
            </el-form-item>
            <el-form-item label="提交报价A">
                 <el-input v-model="dataForm.bidSubmitPrice" disabled></el-input>
            </el-form-item>

            <el-form-item label="提交报价B">
                <el-input v-model="dataForm.bidSubmitPriceIn" disabled></el-input>
            </el-form-item>
            
            <el-form-item  label="中标公司" prop="winBidCompany">
                <el-select ref="bidCompanyRef" filterable allow-create v-model="dataForm.winBidCompany" @change="changeBidCompany" placeholder="请选择中标公司" >
                    <el-option
                    v-for="dict in dict.type.vehicle_bid_company"
                    :key="dict.value"
                    :label="dict.label"
                    :value="dict.label">

                    </el-option>
                </el-select>
                <el-button type="primary" @click="setBid">
                    星驰中标
                </el-button>

                <el-button type="danger" @click="getApiBidResult">
                    API 获取中标结果
                </el-button>
                
            </el-form-item>

            <el-form-item label="中标价格A(客户)" prop="winPrice">
                <el-input v-model="dataForm.winPrice"></el-input>
                <el-button type="primary" @click="handleSyncWinPrice">同步价格</el-button>
            </el-form-item>
            <el-form-item label="中标价格B(内部)" prop="winPrice">
                <el-input v-model="dataForm.winPriceIn"></el-input>
            </el-form-item>

            <el-form-item label="中标状态">
                <el-radio-group v-model="dataForm.winStatus">
                    <el-radio
                    v-for="dict in dict.type.vehicle_bid_win_status"
                    :key="dict.value"
                    :label="dict.value"
                    >{{dict.label}}</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item>
                <el-button @click="handleSubmit">提交</el-button>
                <el-button type="danger" @click="showDialog=false">关闭</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import {updateCaseBidResultByCaseSn} from '@/api/vehicle/case'
    import {getBidResult} from '@/api/vehicle/case-online-api'
    export default {
        props:{
            showStatus: {
                type: [Boolean],
                default:false
            },
            //案件对象详细信息
            caseObj:{
                type:Object,
            }
        },
        dicts:['vehicle_bid_win_status','vehicle_bid_company'],
        computed: {  
            // 创建一个计算属性，它依赖于prop的值  
            showDialog:{  
                // 在这里你可以根据propData的值进行计算或者修改  
                get() {  
                    return this.showStatus;
                },
                set(newValue) {  
                    // 更新对话框的显示状态  
                    this.$emit('close');
                }   
            },
        },  
        watch: {  
            caseObj(newValue, oldValue) {
                this.dataForm.winPrice="";
                // this.dataForm.winStatus="0";
                this.dataForm.insuranceCompany=newValue.insurance.insureCompany;  
                this.dataForm.caseSn=newValue.caseSn;
                this.dataForm.caseId=newValue.caseId;//案件id
                this.dataForm.bidSubmitPrice=newValue.bidChoose.bidSubmitPrice;
                this.dataForm.bidSubmitPriceIn=newValue.bidChoose.bidSubmitPriceIn;
                
                this.dataForm.vehicleSn=newValue.vehicleSn;
                
                this.dataForm.insuranceId=newValue.insurance.insuranceId;
                this.dataForm.winBidCompany="";
                this.dataForm.winPrice="";
                this.dataForm.winPriceIn="";
                // 获取保险公司的id,
                /**
                 * 如果id显示;则 进行显示Button；
                 */
            }  
        }, 
         
        data(){
            return{
                dataForm:{
                    insuranceId:0, // 保险公司的id 获取中标结果使用
                    vehicleSn:'',//车辆编号 
                    insuranceCompany:"",
                    caseId:'',
                    bidSubmitPrice:'',//提交报价A
                    bidSubmitPriceIn:'',//提交报价B

                    caseSn:"",
                    winBidCompany:"",
                    winPrice:"", //中标价格A
                    winPriceIn:"", //中标价格B
                    winStatus:'0',
                },
                rules: {
                    insuranceCompany: [
                        { required: true, message: '保险公司名称不能为空', trigger: 'blur' },
                    ],
                    caseSn: [
                        { required: true, message: '案件号不能为空', trigger: 'blur' },
                    ],
                    winBidCompany: [
                        { required: true, message: '中标公司不能为空', trigger: 'blur' },
                    ],
                    winPrice: [
                        { required: true, message: '中标价格不能为空', trigger: 'blur' },
                    ],
                    winPriceIn: [
                        { required: true, message: '中标价格B不能为空', trigger: 'blur' },
                    ],
                    winStatus: [
                        { required: true, message: '请选择中标状态', trigger: 'blur' },
                    ],
                } 
            }
        },
        methods:{
            //提交,提交成功，则提示并且关闭；提交失败，提示不关闭
            handleSubmit(){
               this.$refs['refDataForm'].validate((valid) => {
                if(valid){
                    console.log(this.dataForm.caseSn);
                    this.$confirm('是否进行提交信息:'+ this.dataForm.caseSn , '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                    updateCaseBidResultByCaseSn(this.dataForm).then(res=>{
                        if(res.success){
                            this.$message.success("提交成功");
                            this.showDialog=false;
                        }else{
                            this.$message.error("提交失败");
                        }
                    });
                    })
                    .catch(error=>{

                    });

                }
               }) 
               
            //    .catch(error=>{
            //         this.$message.error("提交异常");
            //    })
            },

            setBid(){
                const bidCompanyRef = this.$refs.bidCompanyRef;
                
                if (bidCompanyRef.options.length>0){
                    this.dataForm.winBidCompany=bidCompanyRef.options[0].label
                    this.dataForm.winStatus='1'; 
                }
                
                this.$refs.bidCompanyRef.options.forEach(item => {
                    
                });
            },
            changeBidCompany(){

            },

            /**
             * 获取在线接口API的中标结果
             */
            getApiBidResult(){
                console.log(this.dataForm);
                //获取中标结果
                getBidResult(this.dataForm).then(res=>{
                  
                    if(res.success){
                        this.dataForm.winBidCompany=res.data.biddingUser;
                        this.dataForm.winPrice=res.data.bidPrice;
                    }
                })
                .catch(error=>{

                })
            },
            /**
             * 同步价格
             */
            handleSyncWinPrice(){
                this.dataForm.winPriceIn=this.dataForm.winPrice;
            }
        }
    }
</script>